import type { Work } from '@/types';

export const works: Work[] = [
  {
    id: 'm1',
    title: '长夜将尽',
    type: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['悬疑', '剧情'],
    rating: 8.6,
    director: '陆知远',
    cast: ['林澈', '苏晚', '周砚'],
    duration: '118分钟',
    rank: 4,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20artwork%20of%20a%20lone%20detective%20standing%20in%20a%20rainy%20neon%20lit%20alley%20at%20midnight%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20and%20warm%20amber%20color%20grading%2C%20atmospheric%20fog%2C%20minimalist%20vertical%20composition%20with%20negative%20space%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m1-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20neon%20lit%20city%20alley%20at%20midnight%20with%20deep%20navy%20and%20warm%20amber%20tones%2C%20dramatic%20moody%20lighting%2C%20atmospheric%20fog%2C%20reflections%20on%20wet%20pavement%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-m1-backdrop&orientation=landscape',
    summary:
      '一桩尘封十二年的旧案重新浮出水面，早已调离一线的老刑警被迫重返长夜。在真凶与谎言交错的城市里，他必须在黎明到来之前，找回那个被所有人遗忘的答案。',
  },
  {
    id: 'm2',
    title: '山海之间',
    type: 'movie',
    year: 2024,
    region: '中国大陆',
    genres: ['剧情', '家庭'],
    rating: 8.2,
    director: '沈书南',
    cast: ['何砚秋', '江舟', '苏梨'],
    duration: '132分钟',
    rank: 9,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20artwork%20of%20a%20small%20fishing%20village%20by%20misty%20mountains%20and%20sea%20at%20dawn%2C%20warm%20melancholic%20lighting%2C%20muted%20teal%20and%20soft%20amber%20color%20grading%2C%20minimalist%20vertical%20composition%20with%20negative%20space%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m2-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20misty%20mountains%20meeting%20the%20ocean%20at%20dawn%20near%20a%20quiet%20fishing%20village%2C%20soft%20melancholic%20lighting%2C%20muted%20teal%20and%20warm%20amber%20tones%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-m2-backdrop&orientation=landscape',
    summary:
      '离家多年的女儿回到海边小镇，只为处理父亲留下的旧渔船。潮起潮落之间，两代人未说出口的心事被一点点打捞上岸，也让她重新理解了“家”在海与山之间的重量。',
  },
  {
    id: 'm3',
    title: '星际回声',
    type: 'movie',
    year: 2025,
    region: '中国大陆 / 美国',
    genres: ['科幻', '冒险'],
    rating: 9.1,
    director: '顾长风',
    cast: ['陈逸川', 'Amelia Reed', '南星'],
    duration: '146分钟',
    rank: 1,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20poster%20artwork%20of%20a%20lone%20astronaut%20floating%20before%20a%20vast%20glowing%20planet%20ring%2C%20deep%20navy%20space%20with%20warm%20orange%20nebula%20glow%2C%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%20with%20negative%20space%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m3-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20lone%20spacecraft%20drifting%20toward%20a%20vast%20ringed%20planet%20in%20deep%20navy%20space%20with%20warm%20orange%20nebula%20glow%2C%20epic%20dramatic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20sci-fi%20film%20still%20aesthetic&width=1920&height=1080&seq=fy-m3-backdrop&orientation=landscape',
    summary:
      '人类最后一座深空监听站在沉寂三十年后突然收到一段来历不明的回声。一支临时组建的科考队驶向信号源头，却发现那不仅是一段声音，更是一个文明留下来的最后告白。',
  },
  {
    id: 'm4',
    title: '无声告白',
    type: 'movie',
    year: 2024,
    region: '中国大陆',
    genres: ['悬疑', '犯罪'],
    rating: 7.9,
    director: '许清和',
    cast: ['温辞', '韩野', '白鹭'],
    duration: '110分钟',
    rank: 12,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20thriller%20movie%20poster%20artwork%20of%20a%20silhouetted%20figure%20before%20a%20frosted%20glass%20window%20in%20a%20dark%20room%2C%20cold%20navy%20blue%20tones%20with%20a%20single%20warm%20amber%20highlight%2C%20tense%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m4-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dark%20interrogation%20room%20with%20a%20frosted%20glass%20window%2C%20cold%20navy%20blue%20tones%20with%20a%20single%20warm%20amber%20lamp%2C%20tense%20dramatic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-m4-backdrop&orientation=landscape',
    summary:
      '一名聋哑女孩成为凶案的唯一目击者，却无法开口说出真相。年轻女警从她的手语与画作中拼凑线索，逐渐发现沉默背后藏着一场精心设计的告白。',
  },
  {
    id: 'm5',
    title: '春潮渐起',
    type: 'movie',
    year: 2025,
    region: '中国香港',
    genres: ['爱情', '剧情'],
    rating: 8.4,
    director: '许清和',
    cast: ['梁以宁', '程亦', '姚远'],
    duration: '124分钟',
    rank: 6,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20romance%20movie%20poster%20artwork%20of%20two%20figures%20under%20a%20blossoming%20tree%20by%20a%20harbor%20at%20dusk%2C%20warm%20rose%20and%20soft%20amber%20color%20grading%2C%20gentle%20dreamy%20lighting%2C%20minimalist%20vertical%20composition%20with%20negative%20space%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m5-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20harbor%20promenade%20at%20dusk%20with%20blossoming%20trees%20and%20warm%20city%20lights%2C%20romantic%20rose%20and%20amber%20tones%2C%20dreamy%20soft%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-m5-backdrop&orientation=landscape',
    summary:
      '他们在同一个码头错过了十年。一次偶然的重逢，让两段早已分岔的人生再度交汇。春潮渐起，有些感情像潮水一样，退去之后仍会悄悄回来。',
  },
  {
    id: 'm6',
    title: '逆风飞行',
    type: 'movie',
    year: 2023,
    region: '中国大陆',
    genres: ['励志', '运动'],
    rating: 7.6,
    director: '郑一鸣',
    cast: ['方言', '林楚', '苏梨'],
    duration: '116分钟',
    rank: 15,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=inspiring%20sports%20movie%20poster%20artwork%20of%20a%20runner%20sprinting%20through%20a%20windy%20stadium%20at%20sunrise%2C%20energetic%20warm%20orange%20and%20deep%20navy%20color%20grading%2C%20dramatic%20motion%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m6-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20runners%20sprinting%20across%20a%20stadium%20track%20at%20sunrise%20under%20a%20dramatic%20sky%2C%20energetic%20warm%20orange%20and%20deep%20navy%20tones%2C%20motion%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-m6-backdrop&orientation=landscape',
    summary:
      '被伤病判了“死刑”的短跑老将，遇上一位固执的年轻教练。所有人都劝他放弃，他却在逆风里一次次起跑，只为证明终点从来不是年龄决定的。',
  },
  {
    id: 'm7',
    title: '迷雾之城',
    type: 'movie',
    year: 2025,
    region: '日本',
    genres: ['悬疑', '惊悚'],
    rating: 8.8,
    director: '宫岛翔太',
    cast: ['松本悠真', '山崎', '中村澪'],
    duration: '128分钟',
    rank: 3,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20mystery%20movie%20poster%20artwork%20of%20a%20foggy%20highway%20bridge%20disappearing%20into%20dense%20mist%20at%20night%2C%20cold%20steel%20blue%20tones%20with%20a%20faint%20warm%20amber%20streetlight%2C%20eerie%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m7-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%20highway%20bridge%20vanishing%20into%20dense%20mist%20at%20night%2C%20cold%20steel%20blue%20tones%20with%20faint%20warm%20amber%20streetlights%2C%20eerie%20dramatic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1920&height=1080&seq=fy-m7-backdrop&orientation=landscape',
    summary:
      '一场大雾封锁了整座城市，也封锁了一起离奇的失踪案。当能见度降到零，人们才意识到，真正看不清的从来不是前方，而是身边那些熟悉的脸。',
  },
  {
    id: 'm8',
    title: '万物生长',
    type: 'movie',
    year: 2024,
    region: '法国 / 中国大陆',
    genres: ['纪录片', '自然'],
    rating: 9.0,
    director: 'Camille Laurent',
    cast: ['自然摄影团队'],
    duration: '98分钟',
    rank: 5,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=nature%20documentary%20movie%20poster%20artwork%20of%20a%20single%20sprouting%20seed%20in%20a%20vast%20forest%20floor%20with%20sunbeams%20through%20mist%2C%20lush%20green%20and%20warm%20golden%20color%20grading%2C%20serene%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-m8-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20forest%20canopy%20with%20sunbeams%20and%20drifting%20mist%2C%20lush%20green%20and%20warm%20golden%20tones%2C%20serene%20natural%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20nature%20documentary%20aesthetic&width=1600&height=900&seq=fy-m8-backdrop&orientation=landscape',
    summary:
      '镜头横跨五大洲，用四季的更替讲述一粒种子如何长成森林。这是一部关于时间的电影，也是一首献给所有生命的温柔长诗。',
  },
  {
    id: 'm9',
    title: '追光者',
    type: 'movie',
    year: 2025,
    region: '中国大陆',
    genres: ['剧情', '音乐'],
    rating: 8.3,
    director: '陆知远',
    cast: ['苏晚', '方言', '南星'],
    duration: '121分钟',
    rank: 8,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20music%20drama%20movie%20poster%20artwork%20of%20a%20street%20musician%20with%20a%20guitar%20under%20a%20single%20warm%20spotlight%20in%20the%20dark%2C%20deep%20navy%20background%20with%20warm%20amber%20glow%2C%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20film%20poster%20aesthetic&width=400&height=600&seq=fy-m9-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20street%20musician%20performing%20under%20a%20warm%20spotlight%20in%20a%20dark%20city%20square%2C%20deep%20navy%20tones%20with%20warm%20amber%20glow%2C%20dramatic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-m9-backdrop&orientation=landscape',
    summary:
      '一个被乐坛淘汰的制作人，一个从未登过台的街头歌手。两个不甘心的人决定赌上最后一次机会，把无人问津的歌，唱给整个世界听。',
  },
  {
    id: 't1',
    title: '长安夜行录',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['古装', '悬疑'],
    rating: 8.9,
    director: '裴子墨',
    cast: ['萧珩', '沈砚', '纪云舒'],
    duration: '全 40 集',
    rank: 2,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20historical%20drama%20poster%20artwork%20of%20a%20robed%20scholar%20holding%20a%20lantern%20on%20an%20ancient%20palace%20street%20at%20night%2C%20deep%20navy%20and%20warm%20amber%20lantern%20color%20grading%2C%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%20with%20negative%20space%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t1-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20palace%20street%20at%20night%20lit%20by%20hanging%20lanterns%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20historical%20drama%20still%20aesthetic&width=1920&height=1080&seq=fy-t1-backdrop&orientation=landscape',
    summary:
      '盛世长安的繁华之下，夜色里接连发生离奇命案。新任少卿与女仵作携手查案，一卷卷离奇卷宗背后，指向的却是二十年前那场无人敢提的宫变。',
  },
  {
    id: 't2',
    title: '都市浮生',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['都市', '情感'],
    rating: 7.8,
    director: '林晚舟',
    cast: ['许雅', '程亦', '韩野'],
    duration: '全 32 集',
    rank: 14,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20urban%20drama%20poster%20artwork%20of%20a%20young%20woman%20standing%20on%20a%20high%20rise%20balcony%20looking%20over%20a%20night%20city%2C%20deep%20navy%20and%20cool%20amber%20city%20lights%2C%20moody%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t2-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20night%20city%20skyline%20seen%20from%20a%20high%20rise%20balcony%2C%20deep%20navy%20and%20warm%20amber%20city%20lights%2C%20moody%20dramatic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20film%20still%20aesthetic&width=1600&height=900&seq=fy-t2-backdrop&orientation=landscape',
    summary:
      '四个背景各异的年轻人合租在同一栋老楼里。加班的深夜、错过的末班车、说不出口的喜欢，都市浮生里，每个人都在努力活成自己想要的样子。',
  },
  {
    id: 't3',
    title: '苍穹之翼',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['科幻', '剧情'],
    rating: 8.7,
    director: '顾长风',
    cast: ['陈逸川', '南星', '江舟'],
    duration: '全 36 集',
    rank: 7,
    featured: true,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20series%20poster%20artwork%20of%20a%20pilot%20standing%20before%20a%20massive%20futuristic%20aircraft%20in%20a%20hangar%2C%20deep%20navy%20and%20warm%20orange%20accent%20lighting%2C%20dramatic%20tech%20atmosphere%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t3-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20massive%20futuristic%20aircraft%20in%20a%20glowing%20hangar%2C%20deep%20navy%20tones%20with%20warm%20orange%20accent%20lighting%2C%20dramatic%20tech%20atmosphere%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20sci-fi%20series%20still%20aesthetic&width=1920&height=1080&seq=fy-t3-backdrop&orientation=landscape',
    summary:
      '当天空不再属于人类，一群年轻的试飞员被召入秘密基地。他们驾驶着尚未成熟的“苍穹之翼”，在一次次生死试飞中，守护着地面最后的灯火。',
  },
  {
    id: 't4',
    title: '山河故人',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['年代', '家庭'],
    rating: 8.5,
    director: '裴子墨',
    cast: ['何砚秋', '姚远', '白鹭'],
    duration: '全 45 集',
    rank: 10,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20artwork%20of%20a%20family%20silhouette%20before%20a%20riverside%20town%20at%20golden%20dusk%2C%20warm%20sepia%20and%20deep%20navy%20color%20grading%2C%20nostalgic%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t4-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20riverside%20town%20at%20golden%20dusk%20with%20an%20old%20stone%20bridge%2C%20warm%20sepia%20and%20deep%20navy%20tones%2C%20nostalgic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20period%20drama%20still%20aesthetic&width=1600&height=900&seq=fy-t4-backdrop&orientation=landscape',
    summary:
      '一条老街，三代人，四十年的光阴。随着小镇的变迁，这个普通家庭的聚散离合，也默默记录着一个时代最真实的模样。',
  },
  {
    id: 't5',
    title: '罪案边缘',
    type: 'tv',
    year: 2024,
    region: '韩国',
    genres: ['犯罪', '悬疑'],
    rating: 9.0,
    director: '朴正勋',
    cast: ['李在勋', '金敏书', '崔宇'],
    duration: '全 16 集',
    rank: 1,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20series%20poster%20artwork%20of%20a%20detective%20before%20a%20corkboard%20covered%20in%20red%20strings%20and%20photos%2C%20cold%20navy%20blue%20with%20warm%20amber%20highlights%2C%20tense%20dramatic%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t5-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dim%20detective%20office%20with%20a%20corkboard%20full%20of%20red%20strings%20and%20photos%2C%20cold%20navy%20blue%20tones%20with%20warm%20amber%20lamp%20light%2C%20tense%20dramatic%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20series%20still%20aesthetic&width=1600&height=900&seq=fy-t5-backdrop&orientation=landscape',
    summary:
      '一起连环案让三位立场不同的警探被迫合作。随着调查深入，他们发现真相的边界如此模糊，而站在罪案边缘的人，往往离深渊只有一步之遥。',
  },
  {
    id: 't6',
    title: '青春证词',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['青春', '校园'],
    rating: 7.9,
    director: '林晚舟',
    cast: ['许雅', '方言', '苏梨'],
    duration: '全 24 集',
    rank: 16,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20youth%20series%20poster%20artwork%20of%20students%20cycling%20together%20under%20a%20row%20of%20trees%20in%20summer%2C%20bright%20warm%20amber%20and%20soft%20navy%20color%20grading%2C%20nostalgic%20sunlit%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t6-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20students%20cycling%20along%20a%20tree%20lined%20avenue%20in%20summer%2C%20bright%20warm%20amber%20and%20soft%20navy%20tones%2C%20nostalgic%20sunlit%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20series%20still%20aesthetic&width=1600&height=900&seq=fy-t6-backdrop&orientation=landscape',
    summary:
      '高三那年的夏天，一桩被全班隐瞒的旧事重新被翻了出来。当每个人都选择沉默，一个转学生决定写下属于自己的证词，也让青春有了不一样的答案。',
  },
  {
    id: 't7',
    title: '医者仁心',
    type: 'tv',
    year: 2023,
    region: '中国大陆',
    genres: ['医疗', '剧情'],
    rating: 8.1,
    director: '沈书南',
    cast: ['何砚秋', '温辞', '江舟'],
    duration: '全 38 集',
    rank: 13,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20medical%20drama%20poster%20artwork%20of%20a%20surgeon%20in%20scrubs%20walking%20down%20a%20bright%20hospital%20corridor%20at%20dawn%2C%20clean%20soft%20navy%20and%20warm%20amber%20color%20grading%2C%20hopeful%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t7-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20bright%20modern%20hospital%20corridor%20at%20dawn%20with%20light%20streaming%20through%20windows%2C%20clean%20soft%20navy%20and%20warm%20amber%20tones%2C%20hopeful%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20series%20still%20aesthetic&width=1600&height=900&seq=fy-t7-backdrop&orientation=landscape',
    summary:
      '急诊科的走廊从不休息。面对一次次与死神的赛跑，这群医护人员在专业与情感之间不断抉择，也重新理解了“仁心”二字真正的分量。',
  },
  {
    id: 't8',
    title: '商海迷局',
    type: 'tv',
    year: 2024,
    region: '中国大陆',
    genres: ['商业', '悬疑'],
    rating: 8.3,
    director: '郑一鸣',
    cast: ['程亦', '韩野', '纪云舒'],
    duration: '全 30 集',
    rank: 11,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20business%20thriller%20series%20poster%20artwork%20of%20a%20sharp%20suited%20figure%20before%20a%20wall%20of%20glowing%20stock%20charts%2C%20deep%20navy%20with%20warm%20amber%20accent%20lighting%2C%20tense%20dramatic%20atmosphere%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t8-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20dark%20corporate%20boardroom%20with%20glowing%20stock%20charts%20on%20screens%2C%20deep%20navy%20tones%20with%20warm%20amber%20accent%20lighting%2C%20tense%20dramatic%20atmosphere%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20series%20still%20aesthetic&width=1600&height=900&seq=fy-t8-backdrop&orientation=landscape',
    summary:
      '一笔看似普通的并购案，牵出一张横跨十年的资本暗网。年轻的分析师在利益与良知之间越走越深，才明白商海里最贵的从来不是钱，而是真相。',
  },
  {
    id: 't9',
    title: '忘忧客栈',
    type: 'tv',
    year: 2025,
    region: '中国大陆',
    genres: ['古装', '奇幻'],
    rating: 8.6,
    director: '裴子墨',
    cast: ['沈砚', '纪云舒', '萧珩'],
    duration: '全 28 集',
    rank: 9,
    featured: false,
    cover:
      'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20series%20poster%20artwork%20of%20a%20cozy%20ancient%20inn%20glowing%20warmly%20in%20a%20misty%20bamboo%20forest%20at%20dusk%2C%20deep%20navy%20and%20warm%20amber%20lantern%20glow%2C%20dreamy%20magical%20lighting%2C%20minimalist%20vertical%20composition%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20premium%20poster%20aesthetic&width=400&height=600&seq=fy-t9-cover&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20inn%20glowing%20warmly%20in%20a%20misty%20bamboo%20forest%20at%20dusk%2C%20deep%20navy%20tones%20with%20warm%20amber%20lantern%20glow%2C%20dreamy%20magical%20lighting%2C%20highly%20detailed%20digital%20painting%2C%20no%20text%2C%20cinematic%20fantasy%20series%20still%20aesthetic&width=1600&height=900&seq=fy-t9-backdrop&orientation=landscape',
    summary:
      '传说山中有间客栈，只在有缘人迷路时出现。老板能替客人忘掉一件最痛的往事，代价却是忘掉一个最想留住的人。每一集，都是一个关于放下与铭记的故事。',
  },
];
